import { useAuth } from "@/context/AuthContext";
import WorkspaceShell from "@/components/WorkspaceShell";
import StudentWorkspace from "@/components/StudentWorkspace";
import ExamCalendar from "@/features/ExamCalendar";
import TytCalculator from "@/features/TytCalculator";
import { LayoutDashboard, CalendarDays, Calculator } from "lucide-react";

export default function StudentPanel() {
  const { user } = useAuth();
  return (
    <WorkspaceShell
      subtitle="Öğrenci"
      mainNav={[
        { id: "workspace", label: "Çalışma Alanım", icon: LayoutDashboard },
        { id: "exams", label: "Sınav Takvimi", icon: CalendarDays },
        { id: "calc", label: "Puan Hesaplama", icon: Calculator },
      ]}
    >
      {(tab, main) =>
        main === "exams" ? (
          <ExamCalendar focusStudentId={user?.id} />
        ) : main === "calc" ? (
          <div className="space-y-4" data-testid="student-calc">
            <div>
              <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">YKS Puan Hesaplama</h1>
              <p className="text-slate-500 text-sm mt-1">Netlerini gir, ÖSYM kılavuzuna göre tahminî TYT ve SAY / EA / SÖZ puanını gör.</p>
            </div>
            <TytCalculator />
          </div>
        ) : (
        <>
          <div className="mb-5">
            <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">
              Merhaba, {user?.name} 👋
            </h1>
            <p className="text-slate-500 text-sm mt-1">{user?.track || "Alan seçilmedi"} · Programını ve sonuçlarını buradan takip et.</p>
          </div>
          <StudentWorkspace studentId={user?.id} studentName={user?.name} track={user?.track} readOnly={true} tab={tab} />
        </>
        )
      }
    </WorkspaceShell>
  );
}
